import type { FaireProductEntity } from "../../entity_types/product";

export const p_dkdunc5ef4: FaireProductEntity = {
  token: "p_dkdunc5ef4",
  type: "product",
  name: "LM-SP-1000 Sherpa - Navy/Light Blue",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/0a61e3daa9bc76062307c7a0ba933672a262722aa2bc5067102018dc6c159b5d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abfd52f4c460e791c99999a21ebf230f41b3cf15447ca71694ed1105683e7920.jpeg"
  ],
  priceDollars: 39.5,
  description: "This cozy sherpa pullover in navy and light blue delivers casual comfort with a soft, insulating feel ideal for cooler days. It pairs easily with jeans or leggings for versatile styling. Girlie Girl Originals brings a playful, Southern-inspired touch to a fleece essential, making it a reliable addition to seasonal wardrobes and boutique collections.",
  tags: [],
  msrpDollars: 79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:47.510Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
